<template lang="">
  <div class="row">
    <div class="col-md-12">
      <div class="checkbox">
        <label>
          <input
            type="checkbox"
            name="vegan"
            id="vegan"
            value="1"
            v-model="checked"
          />
          {{ message }}
        </label>
      </div>
      <div class="form-group" v-if="checked">
        <label for="vegan-quantity">{{ quantityLabel }}</label>
        <input
          type="number"
          class="form-control"
          name="vegan_quantity"
          id="vegan-quantity"
          v-model.number="quantity"
          :min="1"
          :max="maxPersonsValue"
          :disabled="maxPersonsValue === 0"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  price: {
    type: [Number, String],
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  language: {
    type: [Number, String],
    required: true,
  },
  maxPersons: {
    type: [Number, String],
    required: false,
    default: 0,
  },
});

const checked = ref(0);
const quantity = ref(0);

const lang = computed(() => {
  return props.language == 1 ? "de-DE" : "en-EN";
});

const numericPrice = computed(() => {
  return Number(props.price) || 0;
});

const maxPersonsValue = computed(() => {
  return Math.max(0, Number(props.maxPersons) || 0);
});

watch([checked, maxPersonsValue], () => {
  if (!checked.value) {
    quantity.value = 0;
    return;
  }

  if (maxPersonsValue.value === 0) {
    quantity.value = 0;
    return;
  }

  if (quantity.value < 1) {
    quantity.value = 1;
  }

  if (quantity.value > maxPersonsValue.value) {
    quantity.value = maxPersonsValue.value;
  }
}, { immediate: true });

const message = computed(() => {
  if (numericPrice.value === 0) {
    return props.language == 1 ? "Vegetarisch" : "Vegetarian";
  }

  const price = Intl.NumberFormat(lang, {
    style: "currency",
    currency: "EUR",
  }).format(numericPrice.value / 100);

  return props.language == 1
    ? `Vegetarisch (${price} pro Person)`
    : `Vegetarian (${price} per person)`;
});

const quantityLabel = computed(() => {
  return props.language == 1
    ? "Anzahl vegetarischer Personen"
    : "Number of vegetarian persons";
});
</script>
<style lang=""></style>
